import { render, staticRenderFns } from "./ListSp.vue?vue&type=template&id=6959b820&scoped=true&"
import script from "./ListSp.vue?vue&type=script&lang=js&"
export * from "./ListSp.vue?vue&type=script&lang=js&"
import style0 from "./ListSp.vue?vue&type=style&index=0&id=6959b820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6959b820",
  null
  
)

export default component.exports